import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=548c2aad&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=548c2aad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c2aad",
  null
  
)

export default component.exports